module.exports = __webpack_public_path__ + "img-dashboard/register/player-circle-white.8ae3b3bd.png";